'use client';

import ProductCard from './ProductCard';
import { SearchResponse } from '@/models/Search';
import { PriceData, PriceDataContainer, Product } from '@/models/Product';
import { Category } from '@/models/CategoryDetail';
import CategoryCard from './CategoryCard';
import OptimizedProductCard from './OptimizedProductCard';
import { useEffect, useState } from 'react';
import { fetcher } from '@/lib/Requester';
import { Endpoints } from '@/lib/Endpoints';
import { HTTP_REQUEST } from '@/lib/Constants';

export default function ProductSearchResult({
  searchResult,
  searchKeyword,
}: {
  searchResult: SearchResponse;
  searchKeyword: string;
}) {
  const [pricesData, setPricesData] = useState<PriceData | null>(null);

  useEffect(() => {
    const getPriceData = async () => {
      try {
        const response = await fetcher<PriceDataContainer>({
          params: {},
          cacheKey: '',
          endpoint: Endpoints.PRICES,
          method: HTTP_REQUEST.GET,
          cacheEnabled: false,
        });
        setPricesData(response?.items);
      } catch {
        setPricesData(null);
      }
    };

    getPriceData();
  }, [searchResult, searchKeyword]);

  return (
    <div className="px-4 md:px-0 flex flex-col gap-4 md:gap-8 max-w-7xl w-fit mx-auto mb-8">
      {searchResult.categories && searchResult.categories.length > 0 && (
        <>
          <div className="flex justify-between my-auto">
            <span className="text-hzc_purple_500 font-bold text-xl sm:text-2xl md:text-3xl xl:text-4xl 2xl:text-[44px]">
              Kategoriler
            </span>
            <></>
          </div>
          <div className="mx-auto grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 justify-center">
            {searchResult?.categories?.map((category: Category) => (
              <>
                <CategoryCard key={category.id} category={category} />
              </>
            ))}
          </div>
        </>
      )}
      {searchResult.products && searchResult.products.length > 0 && (
        <>
          <div className="flex justify-between my-auto">
            <span className="text-hzc_purple_500 font-bold text-xl sm:text-2xl md:text-3xl xl:text-4xl 2xl:text-[44px]">
              Ürünler
            </span>
            <></>
          </div>
          <div className="mx-auto grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 justify-center">
            {searchResult?.products?.map((product: Product, index: number) => (
              <OptimizedProductCard
                key={product.id}
                product={product}
                price={pricesData?.[product.id]}
                priority={index < 10}
                listId={'search_result'}
                listName={searchKeyword}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
